module.exports = __webpack_public_path__ + "media/images/cplook/android-chrome-96x96-9e8dec9c2851eb6b0f48e92e1703285c.png";